import Lottery from './Lottery';
import LotteryOption from './LotteryOption';
import LotteryParticipants from './LotteryParticipants';

export const models = {
  Lottery: Lottery,
  LotteryOption: LotteryOption,
  LotteryParticipants: LotteryParticipants,
};
